import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, ShopifyProductsResponseDataSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof ShopifyProductsResponseDataSchema>>

type Props = {
  includeDraft?: boolean
  query: string
}

function normalizeQuery(query: string) {
  return query.trim().replace(/\s+/g, " ")
}

export const shopifySearchProductsQuery = ({ includeDraft = false, query }: Props) => {
  const normalizedQuery = normalizeQuery(query)

  return queryOptions({
    queryKey: ["shopify", "products", normalizedQuery, { includeDraft }],
    queryFn: async () => {
      const response = await axios.get<Response>("/integrations/shopify/products", {
        params: {
          ...(includeDraft && { includeDraft }),
          query: normalizedQuery,
        },
      })

      return response.data.data
    },
    staleTime: 5 * 60 * 1000,
  })
}
